const URL_BASE = 'https://apicondutorlegal.azurewebsites.net/api/v1';

export default URL_BASE;